/**
 * Safe error summaries for logging.
 *
 * An axios error carries the whole request on `error.config`, including
 * `headers.Authorization`. Logging the error object therefore prints a live
 * OAuth access token into the browser console, where extensions and any future
 * log-forwarding integration can read it.
 *
 * Everything that catches a YouTube or Firestore failure logs this summary
 * instead of the error itself.
 */
export function describeError(error) {
  if (!error) return 'unknown error';

  if (typeof error === 'string') return error;

  const status = error?.response?.status ?? error?.status ?? null;
  const code = typeof error?.code === 'string' ? error.code : null;
  const message = typeof error?.message === 'string' && error.message
    ? error.message
    : 'unknown error';

  const parts = [message];
  if (status !== null) parts.push(`status=${status}`);
  if (code) parts.push(`code=${code}`);

  return parts.join(' ');
}
